import React, {Component, useRef} from 'react'
import { Link } from 'react-router-dom'
import {commons} from "../../hook/common";
import history from "../../route/history";

const OpenLink = props => {
    const iframe = React.useRef();

  const goHome = () => {
    history.entries = [];
    history.index = -1;
    history.replace('/mobile/main');
  }

  const goBack = () => {
      window.history.back();
  }

  const goForward = () => {
      window.history.forward();
  }

  const reload = () => {
      window.location.reload();
  }

  return(
    <React.Fragment>
    <div className="openlink-box">
    {/*
      <iframe ref={ref => iframe.current = ref} className="framBox"  src='https://m.utradehub.or.kr/main.do?sso=ok'/>

      <div className="app-box">
         <button className="btnApp app-home" onClick={goHome}>홈</button>
         <button className="btnApp app-pre" onClick={goBack} >이전</button>
         <button className="btnApp app-next" onClick={goForward} >다음</button>
         <button className="btnApp app-refresh" onClick={reload} >새로고침</button>
      </div>
       */}
    </div>
    </React.Fragment>
  )
}

export default OpenLink
